import type { RegistryEntry, UiOptionInput, UiOptionNumber, UiOptionSelect } from '../types';
import { clampTo } from '../../tools';

const COSMOS_NEGATIVE_PROMPT_OPTION = {
  key: 'negative_prompt',
  label: 'Negative Prompt',
  type: 'input',
  default: '',
  group: 'advanced',
} as UiOptionInput;

const COSMOS_INFERENCE_STEPS_OPTION = {
  key: 'num_inference_steps',
  label: 'Inference Steps',
  type: 'number',
  min: 1,
  max: 50,
  step: 1,
  default: 28,
  group: 'advanced',
} as UiOptionNumber;

const COSMOS_GUIDANCE_SCALE_OPTION = {
  key: 'guidance_scale',
  label: 'Guidance Scale',
  type: 'number',
  min: 1,
  max: 20,
  step: 0.5,
  default: 4,
  group: 'advanced',
} as UiOptionNumber;

const COSMOS_OUTPUT_FORMAT_OPTION = {
  key: 'output_format',
  label: 'Output Format',
  type: 'select',
  options: [
    { label: 'JPEG', value: 'jpeg' },
    { label: 'PNG', value: 'png' },
  ],
  default: 'jpeg',
  group: 'basic',
} as UiOptionSelect;

const toCosmosProviderOptions = (ui: Record<string, any>) =>
  ({
    negative_prompt:
      typeof ui.negative_prompt === 'string' && ui.negative_prompt.trim()
        ? ui.negative_prompt.trim()
        : undefined,
    num_inference_steps:
      typeof ui.num_inference_steps === 'number' && Number.isFinite(ui.num_inference_steps)
        ? ui.num_inference_steps
        : 28,
    guidance_scale:
      typeof ui.guidance_scale === 'number' && Number.isFinite(ui.guidance_scale)
        ? ui.guidance_scale
        : 4,
    output_format: clampTo(
      ui.output_format || 'jpeg',
      ['jpeg', 'png'] as const,
      'jpeg',
    ),
  }) as unknown as Record<string, Record<string, any>>;

const cosmosEntry: RegistryEntry = {
  options: [
    COSMOS_OUTPUT_FORMAT_OPTION,
    COSMOS_NEGATIVE_PROMPT_OPTION,
    COSMOS_INFERENCE_STEPS_OPTION,
    COSMOS_GUIDANCE_SCALE_OPTION,
  ],
  toProviderOptions: toCosmosProviderOptions,
};

export const nvidiaConfigs: Record<string, RegistryEntry> = {
  'cosmos-3-super': cosmosEntry,
};